import { gql } from '@apollo/client'

export const CHECK_IN_GUEST = gql`
    mutation editEventAttendee($input: editEventAttendeeInput!) {
        editEventAttendee(input: $input) {
            entity {
                guid
            }
        }
    }
`
